/**
 * Chevron Down Icon
 */

import type { IconProps } from '../../types';

export function ChevronDownIcon({ 
  className, 
  size = 24, 
  color = 'currentColor',
  'aria-label': ariaLabel = 'Expand',
  ...props
}: IconProps) {
  return (
    <svg 
      className={className}
      width={size} 
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label={ariaLabel}
      role="img"
      {...props}
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

